
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dev/scoreboard",
      function () {
        return require("private-next-pages/dev/scoreboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dev/scoreboard"])
      });
    }
  